function getSortValue(item) {
  if (item.nonrunner) {
    return 3;
  }

  if (item.type === '2nd Favourite') {
    return 2;
  }
  if (item.type === 'Favourite') {
    return 1;
  }
  return 0;
}

export const eventsListSorter = (a, b) => {
  const aSortValue = getSortValue(a);
  const bSortValue = getSortValue(b);

  if (aSortValue !== bSortValue) {
    return aSortValue - bSortValue;
  }
  return a.original_order - b.original_order;
};
